import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';

// Ported 1:1 from the prototype `.badge` + colour modifiers (green/gray/warn/danger/info).
export const styles = {
  base: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1nejdyq",
    kZKoxP: "x17rw0jw",
    kg3NbH: "x1q4txso",
    kaIpWk: "xoy5co8",
    kMv6JI: "xdv2sak",
    kGuDYH: "x34ze3o",
    k63SB2: "xomqrzn",
    kb6lSQ: "x1yf5rgg",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  green: {
    kWkggS: "x48i0l6",
    kMwMTN: "x1459q0w",
    $$css: true
  },
  gray: {
    kWkggS: "xvys5x3",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  warn: {
    kWkggS: "x1qf8r77",
    kMwMTN: "x155pc8g",
    $$css: true
  },
  danger: {
    kWkggS: "x8qqj1s",
    kMwMTN: "x2wi9gy",
    $$css: true
  },
  info: {
    kWkggS: "x1mgqhem",
    kMwMTN: "x1a2lix2",
    $$css: true
  }
};